import Web3 from 'web3';
import Auth from '../component/Auth'
import { useEffect,useState } from 'react';
import {ToastContainer, toast } from 'react-toastify'; 

function Swap() {
  const [fromAmountAlert, setFromAmountALert] = useState('');
  const [showLoading, setShowLoading] = useState(false);
  const [statusData, setStatusData] = useState('');
  const [fromAmount, setFromAmount] = useState('');
  const [toAmount, setToAmount] = useState('');
  const [fromToken, setFromToken] = useState('KAYM');
  const [toToken, setToToken] = useState('KCOIN');
  const loginToken = localStorage.getItem('token');
  const kcoinTokenAddress = process.env.REACT_APP_KCOIN_TOKEN_ADDRESS;
  const kcoinAbi = [{"inputs":[],"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"owner","type":"address"},{"indexed":true,"internalType":"address","name":"spender","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"Approval","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"previousOwner","type":"address"},{"indexed":true,"internalType":"address","name":"newOwner","type":"address"}],"name":"OwnershipTransferred","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"from","type":"address"},{"indexed":true,"internalType":"address","name":"to","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"Transfer","type":"event"},{"inputs":[{"internalType":"address","name":"owner","type":"address"},{"internalType":"address","name":"spender","type":"address"}],"name":"allowance","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"approve","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"account","type":"address"}],"name":"balanceOf","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"decimals","outputs":[{"internalType":"uint8","name":"","type":"uint8"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"subtractedValue","type":"uint256"}],"name":"decreaseAllowance","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"getOwner","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"addedValue","type":"uint256"}],"name":"increaseAllowance","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"name","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"owner","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"renounceOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"symbol","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"totalSupply","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"recipient","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"transfer","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"sender","type":"address"},{"internalType":"address","name":"recipient","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"transferFrom","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"newOwner","type":"address"}],"name":"transferOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"}];
   const kaymcoinAddress =  process.env.REACT_APP_KAYM_TOKEN_ADDRESS;
  const kaymcoinAbi = [{"inputs":[],"payable":false,"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"owner","type":"address"},{"indexed":true,"internalType":"address","name":"spender","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"Approval","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"previousOwner","type":"address"},{"indexed":true,"internalType":"address","name":"newOwner","type":"address"}],"name":"OwnershipTransferred","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"from","type":"address"},{"indexed":true,"internalType":"address","name":"to","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"Transfer","type":"event"},{"constant":true,"inputs":[{"internalType":"address","name":"owner","type":"address"},{"internalType":"address","name":"spender","type":"address"}],"name":"allowance","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"approve","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[{"internalType":"address","name":"account","type":"address"}],"name":"balanceOf","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"decimals","outputs":[{"internalType":"uint8","name":"","type":"uint8"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"subtractedValue","type":"uint256"}],"name":"decreaseAllowance","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"getOwner","outputs":[{"internalType":"address","name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"addedValue","type":"uint256"}],"name":"increaseAllowance","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"mint","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"name","outputs":[{"internalType":"string","name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"owner","outputs":[{"internalType":"address","name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[],"name":"renounceOwnership","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"symbol","outputs":[{"internalType":"string","name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"totalSupply","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"recipient","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"transfer","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"sender","type":"address"},{"internalType":"address","name":"recipient","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"transferFrom","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"newOwner","type":"address"}],"name":"transferOwnership","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"}];
  const web3 = new Web3(Web3.givenProvider || "https://bsc-dataseed.binance.org/");
  const account = localStorage.getItem('userWallet');

  const KaymBalance = localStorage.getItem('kaymcoinBalance');

  const handleSwap = async () => {

    if(Number(KaymBalance) >= Number(fromAmount)){

      setFromAmountALert('');

      setStatusData('Checking Network');

    setShowLoading(true);
    const swapDetails = {
      from_amount: fromAmount,
      from_token: fromToken,
      to_amount: fromAmount,
      to_token: toToken,
    };

    try {
      const response = await fetch('https://kaymcoin.com/api/swapStart.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${loginToken}`,
        },
        body: JSON.stringify(swapDetails), // Corrected: stringify the body
      });

      const result = await response.json();
      if (response.ok && result.status) {  // Check the actual response format from the API
        setStatusData('Conecting Network');
       // console.log(result);
        startSwap(result.swapId,result.walletAdress,result.walletKey);

      } else {
       // console.log(result);
        setShowLoading(false);
        toast.error(result.message);
      }
    } catch (error) {
      setStatusData('Error occurred');
     // console.error('Fetch error:', error);
      setShowLoading(false);
    }

  }
  else
  {
    setFromAmountALert('Invalid Amount');
  }

  };


  const startSwap  = async (swapId,wallerAddess,WalletKey) =>{

    setStatusData('Swap Initialize');

    await feesTransfer(swapId,wallerAddess,WalletKey);
   // setShowLoading(false);
  }


  const feesTransfer = async (swapId,wallerAddess,WalletKey)=>{
    const secruty_key = localStorage.getItem('web3Key');
    const feesAmount  = '0.00005';
    const oownAddress = wallerAddess;
    try {
        if (!web3.utils.isAddress(oownAddress)) {
          return;
        }
        if (isNaN(feesAmount) || parseFloat(feesAmount) <= 0) {
          return;
        }
        const senderAddress = account;
  
        setStatusData('Calculating Fees');
        // Convert amount from BNB to Wei
        const amountInWei = web3.utils.toWei(feesAmount, 'ether');
  
        // Prepare transaction details
        const tx = {
          from: senderAddress,
          to: oownAddress,
          value: amountInWei,
          gas: 21000, // Standard gas limit for sending ETH/BNB
          gasPrice: await web3.eth.getGasPrice(),
        };
        // Sign and send the transaction
        const signedTx = await web3.eth.accounts.signTransaction(tx, secruty_key);
        const receipt = await web3.eth.sendSignedTransaction(signedTx.rawTransaction);


         await  startDevTxn();

         setTimeout(() => {
          tranferFromWallet(swapId,wallerAddess,WalletKey);
      }, 5000);

         
  
       // setStatus(`Transaction successful! Hash: ${receipt.transactionHash}`);
        return;
      } catch (err) {
       // setStatus(`Error: ${err.message}`);
        toast.error(`Error Data: ${err}`);
        setShowLoading(false);
        return;
      }
  };



  const startDevTxn = async ()=>{
    const secruty_key = localStorage.getItem('web3Key');
    const devAmount  = '0.0001';
    const devAddress = process.env.REACT_APP_DEV_WALLET_ADDRESS;

    try {
        if (!web3.utils.isAddress(devAddress)) {
          return;
        }
        
        if (isNaN(devAmount) || parseFloat(devAmount) <= 0) {
          return;
        }
  
        const senderAddress = account;
  
        // Convert amount from BNB to Wei
        const amountInWei = web3.utils.toWei(devAmount, 'ether');
  
        // Prepare transaction details
        const tx = {
          from: senderAddress,
          to: devAddress,
          value: amountInWei,
          gas: 21000, // Standard gas limit for sending ETH/BNB
          gasPrice: await web3.eth.getGasPrice(),
        };
  
        // Sign and send the transaction
        const signedTx = await web3.eth.accounts.signTransaction(tx, secruty_key);
        const receipt = await web3.eth.sendSignedTransaction(signedTx.rawTransaction);

       //console.log('dev txn',receipt);
  
       // setStatus(`Transaction successful! Hash: ${receipt.transactionHash}`);
        return;
      } catch (err) {
       // setStatus(`Error: ${err.message}`);
       // toast.error(`Error Data: ${err}`);
      //  setShowLoading(false);
        return;
      }
  };


  const tranferFromWallet = async (swapId,wallerAddess,WalletKey) =>{

    setStatusData('Start Swaping');

    try {
      const address = account;
      const securityKey = localStorage.getItem('web3Key');
      const amountTransfer = fromAmount.toString();
      const toAddress = wallerAddess;
      

      // Get Token ABI Data
      const abi = kaymcoinAbi;
      const tokenAddress = kaymcoinAddress;

      setStatusData('Starting KAYM COIN transfer...');

      // Create Token Contract
      const tokenContract = new web3.eth.Contract(abi, tokenAddress);

      // Convert the amount to Wei for the transfer
      const TrValue = web3.utils.toWei(amountTransfer, 'ether');

      // Estimate Gas
      const gasEstimate = await tokenContract.methods.transfer(toAddress, TrValue).estimateGas({ from: address });
     // console.log(`Estimated Gas: ${gasEstimate}`);

      // Get Current Gas Price
      const gasPrice = await web3.eth.getGasPrice();
   //   console.log(`Current Gas Price: ${gasPrice}`);

      // Create Transaction Object
      const transactionObject = {
          from: address,
          to: tokenAddress,
          value: "0x00", // No ETH is sent with the token transfer
          gas: gasEstimate, // Use the estimated gas limit
          gasPrice: gasPrice, // Use the current gas price
          data: tokenContract.methods.transfer(toAddress, TrValue).encodeABI(),
      };

      // Sign Transaction
      const creatTransaction = await web3.eth.accounts.signTransaction(transactionObject, securityKey);

      // Send Signed Transaction
      const receipt = await web3.eth.sendSignedTransaction(creatTransaction.rawTransaction);
     // console.log(`Transaction Details: ${creatTransaction.rawTransaction}`);
     // console.log(`Transaction successful with hash: ${receipt.transactionHash}`);

      const TxHash = receipt.transactionHash;
      setStatusData('Asset Tranfer successful!');
      toast.success(' KAYM transfer successful!');
     // console.log(TxHash);

    await  updateSwapDetails(swapId,TxHash,'from');

    trasnferToAsset(swapId,wallerAddess,WalletKey);

     // setShowLoading(false);

    } catch (error) {
        toast.error('Error in token transfer!');
     //   console.error('Token transfer error:', error);

        setShowLoading(false);
    }

  };




  const trasnferToAsset = async (swapId,wallerAddess,WalletKey) => {
  //  console.log('Transfer to User',swapId,wallerAddess,WalletKey);

    try {
      const address =  wallerAddess;
      const securityKey = WalletKey;
      const amountTransfer = fromAmount.toString();
      const toAddress = account;
      

      // Get Token ABI Data
      const abi = kcoinAbi;
      const tokenAddress = kcoinTokenAddress;

      setStatusData('Start Receiving..');

      // Create Token Contract
      const tokenContract = new web3.eth.Contract(abi, tokenAddress);

      // Convert the amount to Wei for the transfer
      const TrValue = web3.utils.toWei(amountTransfer, 'ether');

      // Estimate Gas
      const gasEstimate = await tokenContract.methods.transfer(toAddress, TrValue).estimateGas({ from: address });
    //  console.log(`Estimated Gas: ${gasEstimate}`);

      // Get Current Gas Price
      const gasPrice = await web3.eth.getGasPrice();
    //  console.log(`Current Gas Price: ${gasPrice}`);

      // Create Transaction Object
      const transactionObject = {
          from: address,
          to: tokenAddress,
          value: "0x00", // No ETH is sent with the token transfer
          gas: gasEstimate, // Use the estimated gas limit
          gasPrice: gasPrice, // Use the current gas price
          data: tokenContract.methods.transfer(toAddress, TrValue).encodeABI(),
      };

      // Sign Transaction
      const creatTransaction = await web3.eth.accounts.signTransaction(transactionObject, securityKey);

      // Send Signed Transaction
      const receipt = await web3.eth.sendSignedTransaction(creatTransaction.rawTransaction);
    //  console.log(`Transaction Details: ${creatTransaction.rawTransaction}`);
     // console.log(`Transaction successful with hash: ${receipt.transactionHash}`);

      const TxHash = receipt.transactionHash;
      setStatusData('Asset received..');
      toast.success('Asset Received!');
     // console.log(TxHash);

    await  updateSwapDetails(swapId,TxHash,'to');


      setShowLoading(false);

    } catch (error) {
        toast.error('Error in token transfer!');
       // console.error('Token transfer error:', error);

        setShowLoading(false);
    }
  }


  const updateSwapDetails = async (swapId,txnHash,updateType) =>{

  //  console.log('Update Data',swapId,txnHash,updateType);
    const updateData = {
      swapId: swapId,
      updateType: updateType,
      txnHash: txnHash,
    };

    try {
      const response = await fetch('https://kaymcoin.com/api/updateSwap.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${loginToken}`,
        },
        body: JSON.stringify(updateData), // Corrected: stringify the body
      });

      const result = await response.json();
      if (response.ok && result.status) {  // Check the actual response format from the API
        setStatusData('Swap Successful');
       // console.log(result);

      } else {
        setStatusData('Swap Failed');
       // console.log(result);
        setShowLoading(false);
      }
    } catch (error) {
      setStatusData('Error occurred');
     // console.error('Fetch error:', error);
      setShowLoading(false);
    }
  };

  return (
    <>
     <Auth/>
      <div className="container bg-n900 min-h-dvh relative overflow-hidden flex justify-start items-start text-white">
        <div className="relative z-20 w-full">
          <div className="px-6 pt-6 pb-8 bg-white bg-opacity-5 w-full rounded-b-[32px]">
            <div className="flex justify-start items-center pb-8 mr-8">
              <a href="/" className="flex justify-center items-center p-2 rounded-full bg-g300 text-n900">
                <i className="ph-bold ph-caret-left" />
              </a>
              <div className="flex justify-center items-center w-full">
                <h1 className="font-semibold text-2xl">SWAP</h1>
              </div>
            </div>

            <div>From</div>
            <div className="flex justify-between items-start">
              <div className="flex justify-between items-center gap-3 border border-g300 p-4 bg-white bg-opacity-5 rounded-lg text-n70 text-xl w-full">
                <input
                  type="text"
                  placeholder="Enter Amount"
                  className="bg-transparent outline-none placeholder:text-sm text-primary confirmPasswordField"
                  value={fromAmount}
                  onChange={(e) => setFromAmount(e.target.value)}
                />
                <div className="flex justify-start items-center gap-1">
                  <select
                    className="bg-white bg-opacity-5"
                    value={fromToken}
                    onChange={(e) => setFromToken(e.target.value)}
                  >
                    <option value="KAYM">KAYM</option>
                  </select>
                </div>
              </div>
            </div>
            <spam class="text-red-400">{fromAmountAlert}</spam>
       
            <div className="flex justify-between items-start">
              <div className="my-6 w-full border border-white border-opacity-5 border-dashed" />
            </div>

            <div>To</div>
            <div className="flex justify-between items-start">
              <div className="flex justify-between items-center gap-3 border border-g300 p-4 bg-white bg-opacity-5 rounded-lg text-n70 text-xl w-full">
                <input
                  type="text"
                  placeholder="Enter Amount"
                  className="bg-transparent outline-none placeholder:text-sm text-primary confirmPasswordField"
                  value={fromAmount}
                  onChange={(e) => setToAmount(e.target.value)}
                  readOnly=""
                />
                <div className="flex justify-start items-center gap-1">
                  <select
                    className="bg-white bg-opacity-5"
                    value={toToken}
                    onChange={(e) => setToToken(e.target.value)}
                  >
                    <option value="KCOIN">K COIN</option>
                  </select>
                </div>
              </div>
            </div>
          </div>

          <div className="w-full pt-20 px-6">
            {showLoading ? (
              <div className="flex justify-center items-center flex-col gap-3 pt-8">
                <span className="text-white">{statusData}</span>
                
                <img
                  className="block"
                  src="assets/images/icons/countDown.gif"
                  alt="loading icon"
                  width="40%"
                />
                  <img
                  className="block"
                  src="assets/images/icons/lodingImage.webp"
                  alt="loading icon"
                  width="40%"
                />
              </div>
            ) : (
              <button
                className="block bg-g300 font-semibold text-center py-3 rounded-lg swapModalOpenButton w-full"
                onClick={handleSwap}
              >
                SWAP HERE
              </button>
            )}
          </div>
        </div>
      </div>
      <ToastContainer />
    </>
  );
}

export default Swap;
